import { User, UserNoDates } from "@/types/types";

export const getSecondsLeft = (user: User | UserNoDates): number | null => {
  return user.conversionTimeLeftSeconds;
};
